const skills = [
  { slug: "html5", name: "HTML5" },
  { slug: "css3", name: "CSS3" },
  { slug: "javascript", name: "JavaScript" },
  { slug: "typescript", name: "TypeScript" },
  { slug: "vuedotjs", name: "Vue.js" },
  { slug: "nuxtdotjs", name: "Nuxt.js" },
  { slug: "vuetify", name: "Vuetify.js" },
  { slug: "element", name: "Element.js" },
  { slug: "webpack", name: "Webpack" },
  { slug: "jquery", name: "jQuery" },
  { slug: "vite", name: "Vite" },
  { slug: "git", name: "Git" },
  { slug: "nodedotjs", name: "Node.js" },
  { slug: "docker", name: "Docker" },
  { slug: "linux", name: "Linux" },
  { slug: "jenkins", name: "JenKins" },
  { slug: "jira", name: "Jira" },
  { slug: "trello", name: "Trello" },
  { slug: "github", name: "GitHub" },
  { slug: "tailwindcss", name: "Tailwind CSS" },
  { slug: "amazonaws", name: "Aws" },
  { slug: "googlecloud", name: "GCP" },
  { slug: "prettier", name: "Prettier" },
  { slug: "matomo", name: "Matomo.js" },
  { slug: "zendesk", name: "Zendesk.js" },
  { slug: "nestjs", name: "Nest.js" },
  { slug: "serverless", name: "Serverless" },
];

export { skills };
